import { captureException } from '@sentry/browser';

// Dynamic `import()` requests get cancelled by the browser when the user navigates away,
// refreshes, or backgrounds the tab while the chunk is still loading. Safari surfaces this as
// an opaque `TypeError: Importing a module script failed.` with no stack trace or URL, which is
// indistinguishable from a genuinely missing/broken chunk except by this navigation context.
let isPageHidden = document.visibilityState === 'hidden';
let isUnloading = false;

document.addEventListener('visibilitychange', () => {
  isPageHidden = document.visibilityState === 'hidden';
});
window.addEventListener('pagehide', () => {
  isUnloading = true;
});
window.addEventListener('beforeunload', () => {
  isUnloading = true;
});

/**
 * Reports a failed dynamic module import to Sentry, unless the page was already hidden or
 * navigating away when it happened - in that case the failure is expected noise and gets ignored.
 */
export const reportModuleImportError = (error: unknown, extra?: Record<string, unknown>) => {
  if (isPageHidden || isUnloading) {
    return;
  }
  captureException(error, extra ? { extra } : undefined);
};
